import EventPublisher from "../../utils/EventPublisher";
import ActionResultEvents from "../../constants/events/ActionResultEvents";


export default class PublicResponseHandler {

    constructor(responseCodesToCallbacks) {
        this.responseCodesToCallbacks = responseCodesToCallbacks;
    }

    handleResponse(response, dataFromAction) {
        response.json()
            .then((responseBody) => {
                if (this.responseCodesToCallbacks.has(responseBody["code"])) {
                    this.responseCodesToCallbacks.get(responseBody["code"])(
                        response.headers,
                        responseBody["contents"],
                        dataFromAction);
                } else {
                    EventPublisher.publish(
                        ActionResultEvents.SERVER_ERROR,
                        {
                            "error":
                                "Unhandled Code From Server: " +
                                responseBody["code"] +
                                " with message: " +
                                responseBody["message"]
                        });
                }
            }).catch(
                (error) =>
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()}));
    }
}